import React from "react";

export const TestRenderer = props => {
  return <div className={props.className || "testRenderer"}>{props.value}</div>;
};
